import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const ALMMetricModalUI = ({
    context,
    addMetricMode,
    metricType,
    successMsg,
    errorList,
    setErrorList,
    submitted,
    onSubmit,
    onCancelClick,
    metricKey,
    onMetricKeyChange,
    metricKeyError,
    setMetricKeyError
}) =>
    <ModalFormUI
        context={context}
        titleLabel={`Add ${metricType === 'outflow' ? 'Outflow' : 'Inflow'} Metric`}
        buttonLabel='Add'
        cancelLabel='Cancel'
        isOpen={addMetricMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputTextSF type='text' name='metricKey' label='Metric Key'
            value={metricKey} onChange={onMetricKeyChange}
            error={metricKeyError} setError={setMetricKeyError}
            required={true} maxLength={64} autoFocus={true}
        />
    </ModalFormUI>

export default ALMMetricModalUI
